import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { WBMFormatMoney } from "wbm-format-money";

const CartItemChild = ({
  cartItem,
  itemTotal,
  discountTotal,
  useMobile,
  ...props
}) => {
  const kitItemPrice = <WBMFormatMoney amount={itemTotal} useCurrencySign />;
  const discountPrice = (
    <WBMFormatMoney amount={discountTotal} useCurrencySign />
  );

  return (
    <div className="row no-gutters wbmcil-item no-border">
      <div className="col">
        <div
          className={
            "wbmcil-item-details-container pl-0" +
            (useMobile ? " use-mobile" : "")
          }
        >
          <div>
            {cartItem.brandName} {cartItem.description}
          </div>
          <div className="wbmcil-text-gray">
            {cartItem.itemIdentifier.id}
            {cartItem.itemIdentifier.couponOfferCode}
          </div>
        </div>
        <div className="wbmcil-item-image-container">
          <div className="wbmcil-text-gray text-center">
            QTY: {cartItem.qty}
          </div>
        </div>
        <div className="wbmcil-item-pricing-container">
          <b className={discountTotal >= 0 ? "wbmcil-cross-out" : ""}>
            {kitItemPrice}
          </b>
          {discountTotal >= 0 ? (
            <div className="font-weight-bold wbmcil-text-red">
              {discountPrice}
            </div>
          ) : null}
          <div className="wbmcil-text-gray">
            ${cartItem.sellPrice.toFixed(2)} /{" "}
            {cartItem.itemIdentifier.unitId.toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemChild;
